import React, { useState, useRef } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import {
	addVoucher,
	updateKlarna,
	updatePaymentMethod,
	removeVoucher,
	voucherInputChange,
} from '../../actions/checkout';
import { translate } from '../../utils/locale';
import s from './Voucher.scss';

const Voucher = ({ selection, checkout, setup, initVoucherShowing = true, ...props }) => {
	const [voucherShowing, toggleVoucher] = useState(initVoucherShowing);
	const [voucherError, toggleVoucherError] = useState(false);
	const currentVoucherValue = useRef(selection.discounts.discountAsNumber);

	const toggleVoucherHandler = (e) => {
		e.preventDefault();
		toggleVoucher((prevState) => !prevState);
		const $voucherToggle = e.currentTarget;
		window.setTimeout(() => {
			$voucherToggle.nextSibling.querySelector('input').focus();
			$voucherToggle.nextSibling.querySelector('input').setSelectionRange(0, 0);
		}, 0);
	};

	const addVoucherHandler = (e) => {
		e.preventDefault();
		props.addVoucher().then((action) => {
			if (action.type === 'UPDATE_SELECTION') {
				props.updateKlarna();
			}

			if (action.type === 'VOUCHER_ERROR' || action.data.selection.totals.totalDiscountPriceAsNumber === currentVoucherValue.current) {
				toggleVoucherError(true);
				window.setTimeout(() => toggleVoucherError(false), 3000);
			}

			currentVoucherValue.current = action.data.selection.totals.totalDiscountPriceAsNumber;

			return action;
		}).catch((err) => console.log('DEBUG: voucher not added', err));
		props.updatePaymentMethod();
	};

	const removeVoucherHandler = (e) => {
		e.preventDefault();
		const voucherId = e.currentTarget.dataset.voucher;
		props.removeVoucher(voucherId).then((action) => {
			props.updateKlarna();

			const totalDiscount = action.data.selection.totals.totalDiscountPriceAsNumber;
			if (totalDiscount === false) currentVoucherValue.current = 0;
			if (totalDiscount) currentVoucherValue.current = totalDiscount;

			return action;
		}).catch((err) => console.log('DEBUG: voucher not removed', err));
		props.updatePaymentMethod();
	};

	const onVoucherInputChange = (id, value) => {
		props.voucherInputChange(value);
	};

	const hideVoucherError = () => {
		toggleVoucherError(false);
	};

	return (
		<div className={[s.voucher, (voucherShowing ? s.voucher__expanded : null)].join(' ')}>
			<a className={s.voucher_title} href="#toggle-voucher" onClick={toggleVoucherHandler}>
				{ translate(setup, 'checkoutHaveAVoucher') }
				<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
				</svg>
			</a>
			<form className={s.voucher_form} onSubmit={addVoucherHandler}>
				<Input id="voucherCode" type="text" value={checkout.vouchers.currentValue} label={translate(setup, 'checkoutVoucherCode')} inputChange={onVoucherInputChange} isError={checkout.vouchers.error ? translate(setup, 'checkoutVoucherError') : false} />
				<Button variantClasses={['button__inline']} type="submit" text={translate(setup, 'checkoutVoucherUse')} />
			</form>
			<button className={[s.voucher_error, (voucherError ? s.voucher_error__showing : null)].join(' ')} type="button" onClick={hideVoucherError}>
				{ translate(setup, 'checkoutVoucherErrorAlert') }
			</button>
			{
				selection?.discounts?.anyDiscount && selection.discounts.vouchers.length > 0 && (
					<div className={s.voucher_added}>
						{
							selection.discounts.vouchers.map((voucher) => (
								<div key={voucher.voucher} className={s.voucher_added_row}>
									<span>{ translate(setup, 'checkoutVoucherAdded') }</span>
									<div>
										<span>{ voucher.voucher }</span>
										<a href="#removeVoucher" data-voucher={voucher.voucher} onClick={removeVoucherHandler}>
											{ translate(setup, 'remove') }
											<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1.2011 9L9 1.09436L7.92042 0L0.151003 7.87575L1.2011 9Z" fill="black" />
												<path d="M7.7989 9L0 1.09436L1.07958 0L8.849 7.87575L7.7989 9Z" fill="black" />
											</svg>
										</a>
									</div>
								</div>
							))
						}
					</div>
				)
			}
		</div>
	);
};

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, {
	addVoucher,
	updateKlarna,
	updatePaymentMethod,
	removeVoucher,
	voucherInputChange,
})(Voucher));
